module.exports = __webpack_public_path__ + "static/media/btn-enviar-pergunta-loock.4b500be4.png";